import { vsItems } from './constants'
import type { VelocitySimulationItem, VelocitySimulationItemType } from './types'

export const getFullNavItems = (
  additionalInfo: Partial<Record<VelocitySimulationItemType, string>>,
): VelocitySimulationItem[] =>
  vsItems.map(item => ({ ...item, additionalText: additionalInfo[item.id] }))
